var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2128 2.16643V11.9019C19.8274 11.7482 19.4074 11.6629 18.9644 11.6629C17.8368 11.6629 16.8358 12.2091 16.226 13.0455C15.8176 13.5975 15.5759 14.2746 15.5759 15.0086C15.5759 16.3741 16.3986 17.552 17.578 18.0754H17.3651C16.669 18.0754 16.1052 18.633 16.1052 19.3215V22.3258H4.17935C3.52927 22.3258 3 21.8023 3 21.1537V2.16643C3 1.52347 3.52927 1 4.17935 1H19.0334C19.6835 1 20.2128 1.52347 20.2128 2.16643Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5024 4.77832H7.44824V6.65599H15.5024V4.77832Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08887 9.79102H17.0425",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2255 13.0454H6.08887",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 16.3057H8.28027",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2687 11.9021C19.8833 11.7484 19.4633 11.6631 19.0203 11.6631C17.8927 11.6631 16.8917 12.2093 16.2819 13.0457C15.8735 13.5977 15.6318 14.2748 15.6318 15.0088C15.6318 16.3743 16.4545 17.5521 17.6339 18.0756C17.8064 18.1553 17.9905 18.2179 18.1804 18.2577C18.445 18.3317 18.7269 18.3658 19.0203 18.3658C19.3137 18.3658 19.5956 18.326 19.866 18.2577C20.0041 18.2236 20.1364 18.178 20.2687 18.1268C20.3147 18.1154 20.3608 18.0927 20.401 18.0756C21.5861 17.5521 22.4088 16.3743 22.4088 15.0088C22.4088 13.6432 21.5228 12.3857 20.2687 11.9021ZM20.2687 16.4426C19.935 16.7328 19.4921 16.9035 19.0203 16.9035C17.9618 16.9035 17.1046 16.0557 17.1046 15.0088C17.1046 13.9618 17.9618 13.1197 19.0203 13.1197C19.4921 13.1197 19.935 13.2904 20.2687 13.5806C20.6714 13.9277 20.9303 14.4398 20.9303 15.0088C20.9303 15.5777 20.6714 16.0955 20.2687 16.4426Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9312 15.0087C20.9312 15.5834 20.6723 16.0955 20.2696 16.4425C19.9359 16.7327 19.4929 16.9034 19.0212 16.9034C17.9627 16.9034 17.1055 16.0556 17.1055 15.0087C17.1055 13.9617 17.9627 13.1196 19.0212 13.1196C19.4929 13.1196 19.9359 13.2903 20.2696 13.5805C20.6723 13.9276 20.9312 14.4397 20.9312 15.0087Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8863 19.3218V25.0003L19.867 24.107L19.0098 23.7258L18.1814 24.0956L16.1621 25.0003V19.3218C16.1621 18.6333 16.7259 18.0757 17.422 18.0757H17.6349C17.8075 18.1553 17.9915 18.2179 18.1814 18.2578C18.446 18.3317 18.7279 18.3659 19.0213 18.3659C19.3147 18.3659 19.5966 18.326 19.867 18.2578C20.0051 18.2236 20.1374 18.1781 20.2697 18.1269C20.3157 18.1155 20.3618 18.0928 20.402 18.0757H20.6206C21.3167 18.0757 21.8863 18.6333 21.8863 19.3218Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8663 18.2573V24.1066L19.0091 23.7253L18.1807 24.0952V18.2573C18.4453 18.3313 18.7272 18.3654 19.0206 18.3654C19.314 18.3654 19.5959 18.3256 19.8663 18.2573Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.afb6f97b5a72ed66b4609110735a8c7f.svg";
export { ForwardRef as ReactComponent };